{OrgDetails,UserDetails} = window.DuocmsAdmin.modules # copy original components

window.DuocmsAdmin.modules.OrgDetails = require("./admin/OrgDetails")(OrgDetails) # create override, giving original
window.DuocmsAdmin.modules.UserDetails = require("./admin/UserDetails")(UserDetails) # create override, giving original

window.DuocmsAdmin.start()